import productStepConfig from './ProductStep';
import inventoryStepConfig from './InventoryStep';

const buildSteps = (isBrandUser) => {
  if (isBrandUser) {
    return [
      productStepConfig,
      inventoryStepConfig,
    ];
  }

  return [productStepConfig];
};

export default buildSteps;
